<template>
  <div class="rejected-offer">
    <div class="row">
      <div class="col-3 rejected-logo"><img :src="logoURL" v-if="logoURL" /></div>
      <div class="col-9 rejected-title">{{title}}</div>
    </div>
    <div class="row">
      <div class="col-auto offer-description" v-show="description" v-html="description"></div>
    </div>
    <br/>
    <div class="row" v-if="campusName">
      <div class="col-4">Campus Name:</div>
      <div class="col-8 offer-campus-name">{{campusName}}</div>
    </div>
    <div class="row" v-if="programName">
      <div class="col-4">Program Name:</div>
      <div class="col-8 offer-program-name">{{programName}}</div>
    </div>
    <div class="row">
      <div class="col-auto offer-reject-reason">
        <h5>Reason:</h5>
        <ul v-if="typeof reason === 'string'">
          <li>
            {{reason}}
          </li>
        </ul>
        <template v-else>
          <ul>
            <li v-for="(subReason, index) in reason" :key="index">
            {{subReason}}
            </li>
          </ul>
        </template>

      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'RejectedOffer',
  props: ['offer'],
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    logoURL () {
      return this.offer.offer.logoURL
    },
    title () {
      return this.offer.offer.name
    },
    subjects () {
      return this.offer.offer.subjects
    },
    description () {
      return this.offer.offer.shortDescription
    },
    reason () {
      return this.offer.errors[''] ? this.offer.errors[''] : this.offer.errors
    },
    programName () {
      return this.offer.programName
    },
    campusName () {
      return this.offer.campusName
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.rejected-offer {
  padding-top: 10px;
  padding-bottom: 15px;
}
.rejected-logo img {
  max-width: 100%;
  max-height: 45px;
  width: auto;
  height: auto;
}
.unskip {
  float: right;
}
</style>
